import { MerchantAPIScope } from './merchantAPIScope';

export class MerchantAPIInfoData {
  clientId: string;
  clientKey: string;
  enabled: boolean;
  scopes: MerchantAPIScope[];
  sandboxClientId: string;
  sandboxClientKey: string;
  sandboxScopes: MerchantAPIScope[];
  sandboxEnabled: boolean;

  constructor(m: Partial<MerchantAPIInfoData>) {
    this.clientId = m.clientId ?? '';
    this.clientKey = m.clientKey ?? '';
    this.enabled = m.enabled ?? false;
    this.scopes = m.scopes ?? [];
    this.sandboxClientId = m.sandboxClientId ?? '';
    this.sandboxClientKey = m.sandboxClientKey ?? '';
    this.sandboxScopes = m.sandboxScopes ?? [];
    this.sandboxEnabled = m.sandboxEnabled ?? false;
  }

  static createEmpty(): MerchantAPIInfoData {
    return new MerchantAPIInfoData({
      clientId: '',
      clientKey: '',
      enabled: false,
      scopes: [],
      sandboxClientId: '',
      sandboxClientKey: '',
      sandboxScopes: [],
      sandboxEnabled: false,
    });
  }
}
